<template>
  <RouterView />
  <div class="theme-switcher d-flex align-items-center gap-2">
        <button class="button-switch" @click="toggleTheme">
            <img v-if="theme === 'dark'" src="/assets/images/svg/sun.svg" alt="Light Mode" >
            <img v-else src="/assets/images/svg/moon.svg" alt="Dark Mode" >
        </button>
  </div>
</template>

<script setup>

const Header = () => import('@/components/Header.vue');
const Footer = () => import('@/components/Footer.vue');

import { ref, watchEffect } from 'vue'

const theme = ref(localStorage.getItem('theme') || 'light')
const toggleTheme= () => {
      theme.value = theme.value === 'dark' ? 'light' : 'dark'
    }
watchEffect(() => {
  const classList = document.body.classList
  classList.remove('light-theme', 'dark-theme')
  classList.add(`${theme.value}-theme`)
  localStorage.setItem('theme', theme.value)
})
</script>

<style>

</style>
